import globalAxios from 'axios';
import { PublicClientApplication, SilentRequest } from '@azure/msal-browser';

const SKIP_INTERCEPTOR_URLS = [
  `${process.env.REACT_APP_ASSET_SERVICE_URL}/feature-flags`, // Feature Flag API does not require authentication
];

const setupAccessTokenInterceptor = (msalInstance: PublicClientApplication) => {
  const accounts = msalInstance.getAllAccounts();
  const getAccessToken = () => {
    const request: SilentRequest = { scopes: ['openid'], account: accounts[0], forceRefresh: true };
    return msalInstance.acquireTokenSilent(request).catch(error => {
      console.log(error);
      console.log('silent token acquisition fails. acquiring token using redirect');

      // fallback to interaction when silent call fails
      return msalInstance
        .acquireTokenRedirect(request)
        .then(tokenResponse => {
          return tokenResponse;
        })
        .catch(error => {
          console.log(error);
        });
    });
  };

  // This interceptor is only applied for requests made using the global axios instance (https://github.com/axios/axios/issues/993)
  // The auto-generated clients should use the global axios instance for all requests they make
  globalAxios.interceptors.request.use(async config => {
    if (config.url && !SKIP_INTERCEPTOR_URLS.includes(config.url)) {
      const accessTokenResponse = await getAccessToken();
      if (accessTokenResponse && config.headers) {
        config.headers.Authorization = `Bearer ${accessTokenResponse.idToken}`;
        return config;
      }
    }
    return config;
  });
};

export default setupAccessTokenInterceptor;
